import React from 'react';

const SkeletonBlock = ({ className = '' }) => (
  <div className={`animate-pulse rounded-lg bg-neutral-200 dark:bg-neutral-800 ${className}`} />
);

export const ProjectFeedSkeleton = ({ count = 4 }) =>
  Array.from({ length: count }).map((_, index) => (
    <article
      key={`project-skeleton-${index}`}
      className="overflow-hidden rounded-xl border border-neutral-200 bg-white dark:border-neutral-800 dark:bg-neutral-950"
    >
      <SkeletonBlock className="aspect-[16/10] w-full rounded-none" />
      <div className="space-y-3 p-4">
        <SkeletonBlock className="h-4 w-2/3" />
        <SkeletonBlock className="h-3 w-1/4" />
        <SkeletonBlock className="h-3 w-full" />
        <div className="flex items-center justify-between border-t border-neutral-100 pt-3 dark:border-neutral-900">
          <SkeletonBlock className="h-3 w-24" />
          <SkeletonBlock className="h-7 w-7 rounded-md" />
        </div>
      </div>
    </article>
  ));
